// extracted by mini-css-extract-plugin
module.exports = {"container":"SeoLinks_container__qy0l6","linkSection":"SeoLinks_linkSection__v4Zui"};